<template>
    <div class="mb-n4">
        <div class="mb-4">
            <div class="font-weight-bold mb-1">Mode de paiement</div>
            <div>{{ paymentModeLabel }}</div>
        </div>

        <div class="mb-4">
            <div class="font-weight-bold mb-1">Adresse de facturation</div>
            <template v-if="order.invoice_address">
                <AddressLabel :address="order.invoice_address" />
            </template>
        </div>

        <template v-if="order.attachment">
            <div class="mb-4">
                Pièce jointe: {{ order.attachment.file }}
            </div>
        </template>
    </div>
</template>

<script>
    import AddressLabel from "../../../addresses/AddressLabel";
    import { paymentModeLabel } from "../../../../util/register";

    export default {
        components: {
            AddressLabel,
        },
        props: {
            order: Object,
        },
        computed: {
            paymentModeLabel() {
                return paymentModeLabel(this.order.payment_mode);
            }
        },
    }
</script>
